import { cn } from '@wellesley/ui'
import { MapPin, X } from 'lucide-react'
import { forwardRef } from 'react'

type LocationTogglerProps = {
  isHighlighted: boolean
  hasCloseButton: boolean
  onToggle: () => void
  onCrossClick: (e: React.MouseEvent<SVGSVGElement>) => void
}

const LocationToggler = forwardRef<HTMLDivElement, LocationTogglerProps>(
  ({ isHighlighted, hasCloseButton, onToggle, onCrossClick }, ref) => (
    <div ref={ref}>
      <button
        type="button"
        onClick={onToggle}
        data-testid="location-selector-toggler"
        className={cn(
          'gap-xxs h-m flex w-6 cursor-pointer items-center text-gray-500 max-md:flex-1 max-md:justify-center',
          {
            'p-xxs w-10 rounded-[6px] bg-gray-100 text-blue-500': isHighlighted,
            'w-16': hasCloseButton,
          },
        )}
      >
        <MapPin size={24} strokeWidth={2} className="cursor-pointer" />
        {hasCloseButton && (
          <X
            size={16}
            color="var(--gray-400)"
            data-testid="location-toggler-clear"
            onClick={(e) => {
              e.stopPropagation()
              onCrossClick(e)
            }}
            className="cursor-pointer"
          />
        )}
      </button>
    </div>
  ),
)

LocationToggler.displayName = 'LocationToggler'

export default LocationToggler
